import type { BidAskPPS, BidAskRate } from '@/utils/number-point.ts';

type Parameters = {
  traderFarDeltaRate: BidAskRate;
  marginSwapPps: BidAskPPS;
  currencyPairPrecision: number;
};

// FarPointsClientBid (Client Far points)
// =FarPointsTraderBid-SwapComMarginBid
export function computeFarDeltaRate({
  traderFarDeltaRate,
  marginSwapPps,
  currencyPairPrecision,
}: Parameters): BidAskRate {
  return {
    bid: traderFarDeltaRate.bid - marginSwapPps.bid * 10 ** -currencyPairPrecision,
    ask: traderFarDeltaRate.ask + marginSwapPps.ask * 10 ** -currencyPairPrecision,
  };
}
